import {headers} from '../common'

async function getListData(param) {
  const queryParams = new URLSearchParams(param);

  return fetch(`/api/shops?${queryParams}`
  ).then(res => {
    return res;
  })
  .catch(errors => {
    return errors;
  })
}

async function getCompanyOfShop(shop_id) {

  return fetch('/api/shops/' + shop_id + '/get-company'
  ).then(res => {
    return res;
  })
  .catch(errors => {
    return errors;
  })
}

export { getListData, getCompanyOfShop }
